const updateLocation = (location) => ({
  type: 'UPDATE_LOCATION',
  location,
});

export default updateLocation;
